import { buildModelService } from "./adminAPI";

export const groupService = buildModelService("/groups");
